/**
 * 面值/商品服务过滤器
 * @params Object
 *        {
 *             有效天数
 *             validDaily: String,
 *             生效时间
 *             useValidTime: String,
 *             过期时间
 *             useInvalidTime: String,
 *         }
 */
import dateFormat from './dateFormat';

export default function couponValidTime({
    validDaily = '',
    useValidTime = '',
    useInvalidTime = '',
}) {
    let str = '';
    if (validDaily != null) {
        str = `${validDaily}天`;
    } else {
        str = `${dateFormat(useValidTime, 'YYYY/MM/DD')}至${dateFormat(useInvalidTime, 'YYYY/MM/DD')}`;
    }
    return str;
}
